/* eslint-disable no-param-reassign */
/* eslint-disable prefer-promise-reject-errors */
import { axios } from '@carvana/purchase-utils';

export const completeRequest = payload =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v2/CustomerRequests/Complete`,
    data: payload
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));

function dataURItoBlob(dataURI, type) {
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type });
}

const getUploadDocumentUrlByType = requestType => {
  switch (requestType) {
    case 'CashInAdvance':
      return `${process.env.API_URL}/api/v2/CustomerRequests/UploadCashInAdvanceDocument`;
    default:
      return `${process.env.API_URL}/api/v2/CustomerRequests/UploadDocument`;
  }
};

export const documentUploadDocument = payload => {
  const formData = new FormData();
  const {
    image,
    customerId,
    customerRequestId,
    purchaseId,
    vehicleId,
    requestType
  } = payload;

  const { src, type, name } = image;
  formData.append('customerId', customerId);
  formData.append('customerRequestId', customerRequestId);
  formData.append('document', dataURItoBlob(src, type), name);
  formData.append('purchaseId', purchaseId);
  formData.append('vehicleId', vehicleId);
  formData.append('purchaseId', purchaseId);

  return axios({
    method: 'post',
    url: getUploadDocumentUrlByType(requestType),
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  });
};

export const fetchCustomerRequests = (
  customerId,
  vehicleId
) =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v2/CustomerRequests/${customerId}/${vehicleId}`
  })
    .then(res => {
      return res.data;
    })
    .catch(err => Promise.reject(err?.response));

export const fetchVerifications = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/verification`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
